(function (window, document, cookieConsentName, dataLayerName) {
  window[cookieConsentName] = window[cookieConsentName] || {};
  window[dataLayerName] = window[dataLayerName] || [];
  const dialog = document.getElementById('cookie-consent-banner');
  let dispose;

  const hide = () => {
    if (dispose) {
      dispose();
      dispose = undefined;
    }

    dialog.hidden = true;
  };

  const show = () => {
    const cookieConsent = window[cookieConsentName].consent;
    const { options } = cookieConsent;
    const cookieConsentSettings = window[cookieConsentName].settings;
    const buttonAll = document.getElementById('cookie-consent-banner-all');
    const buttonSettings = document.getElementById('cookie-consent-banner-setting');
    const linkCookiePolicy = document.getElementById('cookie-consent-banner-cookie-policy');

    const handleSettings = () => {
      window[dataLayerName].push({
        event: `${cookieConsentName}.banner`,
        cookieBannerAction: 'click',
        cookieBannerLabel: 'Settings',
      });

      cookieConsentSettings.show();
    };

    const handleAll = () => {
      window[dataLayerName].push({
        event: `${cookieConsentName}.banner`,
        cookieBannerAction: 'click',
        cookieBannerLabel: 'Accept All',
      });

      const consent = {};

      for (const i in options) {
        consent[options[i]] = true;
      }

      cookieConsent.set(consent);
      hide();
    };

    const handleCookiePolicy = () => {
      window[dataLayerName].push({
        event: `${cookieConsentName}.banner`,
        cookieBannerAction: 'click',
        cookieBannerLabel: 'Cookie policy',
      });
    };

    buttonAll.addEventListener('click', handleAll);
    buttonSettings.addEventListener('click', handleSettings);
    linkCookiePolicy.addEventListener('click', handleCookiePolicy);

    dispose = () => {
      buttonAll.removeEventListener('click', handleAll);
      buttonSettings.removeEventListener('click', handleSettings);
      linkCookiePolicy.removeEventListener('click', handleCookiePolicy);
    };

    dialog.hidden = false;
  };

  window[cookieConsentName].banner = { hide, show };
}(window, document, 'cookieConsent', 'dataLayer'));
